module.exports = __webpack_public_path__ + "img/mohamadghali3.bb604018.png";